import React from 'react';
import './index.css';

import { Outlet } from 'react-router-dom';
import { AuthProvider } from './Auth/AuthProvider';
import { ModalProvider } from './contexts/ModalContext';
import { ToastProvider } from './contexts/ToastContext';

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
        <ToastProvider>
          <div className="App">
            <Outlet />
          </div>
        </ToastProvider>
      </ModalProvider>
    </AuthProvider>
  );
}

export default App;